<template>
  <div>
    <md-progress-spinner v-if="downloading" md-mode="indeterminate" :md-diameter="25" :md-stroke="2"/>
    <md-button v-else @click="doDownload">Download</md-button>
  </div>
</template>

<script>
  export default {
    props: {
      pics: Array,
      zipFileName: String,
      filePrefixForEachFile: String,
    },
    data: () => ({ downloading: false }),
    mounted() {
      this.downloading = false;
    },
    watch: {
      pics() {
        this.downloading = false;
      },
      zipFileName() {
        this.downloading = false;
      },
    },
    methods: {
      doDownload() {
        this.downloading = true;
        const zipFileName = this.zipFileName || 'pictures.zip';
        const filePrefixForEachFile = this.filePrefixForEachFile || '';
        const promises = _(this.pics)
          .map((url) => {
            const a = document.createElement('a');
            a.href = url;

            const req = {
              method: 'GET',
              mode: 'no-cors',
              cache: 'default',
            };

            const pathName = a.pathname;
            console.log(pathName);
            return fetch(pathName, req);
          });


        Promise.all(promises)
          .then((responses) => {

            this.downloading = false;
            console.log(`aa`);
            const zip = new JSZip();

            _(responses)
              .each((res) => {
                console.log(res);
                console.log(res.body);
                let filename = res.url.replace(/.*\//g, "");
                if (!filename.endsWith('png') || !filename.endsWith('jpg')) {
                  filename += '.png';
                }
                filename = decodeURI(filename);
                console.log(`filename=${filename}`);
                const blob = res.blob();
                zip.file(`${filePrefixForEachFile}${filename}`, blob, { binary: true });
              });

            zip.generateAsync({ type: "blob" })
              .then((blob) => {
                const a = $("<a style='display: none;'/>");
                const url = window.URL.createObjectURL(blob);
                a.attr("href", url);
                a.attr("download", zipFileName);
                $("body")
                  .append(a);
                a[0].click();
                window.URL.revokeObjectURL(url);
                a.remove();
              });
          })
          .catch(() => this.downloading = false);
      },
    },
  };
</script>
